import { useMemo } from 'react'
import { SecurityAssessmentsModule } from '@/core/modules/security-assessments/security-assessments.module'
import { getRiskLevelBySecurityScore, RISKS_CONFIG } from '@/ui/utils/utils'
import { useAllIssues } from '@/ui/routes/issues/hooks/useAllIssues'

export const useRiskLevelSeverity = (): TIssueSeverity => {
    const { securityScore } = SecurityAssessmentsModule.useStore()
    const { data } = useAllIssues()

    return useMemo(() => {
        if (securityScore != null) {
            const riskLevel = getRiskLevelBySecurityScore(securityScore)
            return RISKS_CONFIG[riskLevel].severity
        }

        const issues = data?.filter(
            (issue: TIssue | TCloudAppIssue) => issue.status === 'open'
        )

        if (!issues || issues.length === 0) {
            return RISKS_CONFIG.EXCELLENT.severity
        }

        let maxSeverityScore = 0
        let highestSeverity: TIssueSeverity = RISKS_CONFIG.EXCELLENT.severity

        for (const issue of issues) {
            const { severity: issueSeverity, severity_score: severityScore } =
                issue

            if (issueSeverity === RISKS_CONFIG.HIGH_RISK.severity) {
                return RISKS_CONFIG.HIGH_RISK.severity
            }

            if (severityScore && severityScore > maxSeverityScore) {
                maxSeverityScore = severityScore
                highestSeverity = issueSeverity
            }
        }

        return highestSeverity
    }, [securityScore, data])
}
